import { RouteObject } from 'react-router-dom';
import ProtectionOrderNotProtectedPage from '~/app/features/protection-order/not-protected/ProtectionOrderNotProtectedPage';
import ProtectionOrderOverviewPage from '~/app/features/protection-order/overview/ProtectionOrderOverviewPage';
import { loader as protectionOrderOverviewLoader } from '~/app/features/protection-order/overview/protectionOrderOverview';
import ShippingProtectionClaimOverviewPage from '~/app/features/shipping-claim/claim-overview/ShippingClaimOverviewPage';
import { loader as shippingProtectionClaimOverviewLoader } from '~/app/features/shipping-claim/claim-overview/shippingClaimOverview';

import { middleware } from './middleware';
import NewClaim from './new';

export default {
  path: ':idFromPlatform',
  handle: {
    middleware,
  },

  children: [
    {
      index: true,
      Component: ProtectionOrderOverviewPage,
      loader: protectionOrderOverviewLoader,
    },
    {
      id: 'protectionOrderNotProtected',
      path: 'not-protected',
      Component: ProtectionOrderNotProtectedPage,
    },
    {
      id: 'shippingProtectionClaimOverview',
      path: 'claim/:claimId/:entryPoint?',
      Component: ShippingProtectionClaimOverviewPage,
      loader: shippingProtectionClaimOverviewLoader,
    },
    NewClaim,
  ],
} satisfies RouteObject;
